export type MenuMotionTier = "low" | "balanced" | "high";

export interface MenuMotionHints {
  nativePlatform: boolean;
  platform: string;
  userAgent: string;
  logicalProcessors?: number;
  deviceMemoryGb?: number;
}

const validHint = (value: number | undefined): number | undefined =>
  typeof value === "number" && Number.isFinite(value) && value > 0 ? value : undefined;

/** A conservative first-paint budget, not a benchmark or an FPS guarantee.
 * Unknown hardware stays balanced; more decoration requires both CPU and RAM
 * evidence. Actual arena quality is independently adapted from measured frames. */
export function resolveMenuMotionTier(hints: MenuMotionHints): MenuMotionTier {
  const cpu = validHint(hints.logicalProcessors);
  const memory = validHint(hints.deviceMemoryGb);
  const mobile = /Android|iPhone|iPad|Mobile/i.test(hints.userAgent)
    || (hints.nativePlatform && ["android", "ios"].includes(hints.platform));
  const chromium = /\b(?:Chrome|Chromium)\/(\d+)/i.exec(hints.userAgent);
  const legacyMobile = mobile && chromium !== null && Number(chromium[1]) > 0 && Number(chromium[1]) <= 99;
  if (legacyMobile || (cpu !== undefined && cpu <= 4) || (memory !== undefined && memory <= 4)) return "low";
  return cpu !== undefined && cpu >= 8 && memory !== undefined && memory >= 8 ? "high" : "balanced";
}
